<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <div>
                        IC: 半徑10公里內有雲間閃電<br>
                        CG: 半徑10公里內有雲地閃電<br>
                    </div>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js";
    import { sort_table_data } from "@/utils/monitor/common_tool.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js";
    import { monitor_signs_normal_mapping, TABLE_VALUE_TEXT_MAPPING } from "../../../config/monitor_config";
    import cloneDeep from 'lodash/cloneDeep';
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue";

	export default {
        name: 'port_lightning',

        components: { 
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable 
        },

        mixins: [monitor_mixin],
      
		data() {
			return {
                header: [],
                immutable_table_data: [],
                table_data: [],
                default_value: 236,
                error_text: '',

                should_show_raw_html_header: ['警示'],

                search: ''
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data
                this.table_data = this.reconstruct_alert_icon(sort_table_data(data, monitor_signs_normal_mapping));
                this.header = header;
            },

            reconstruct_alert_icon(data) {
                return cloneDeep(data).map(datum => {
                    if(datum['警示'] === '有') {
                        return Object.assign(datum, {
                            '警示': [{
                                'html': `<span class="dot" style="background: #FF0000" />`
                            }]
                        })
                    }
                    return datum
                });
            },
        },
	}
</script>